import { useMemo } from 'react';

import QRCode from 'qrcode.react';
import { Box, Divider, Group, Stack, Text, cx } from 'ui';

import { EventDateTime } from '../EventDateTime';
import { EventLocation } from '../EventLocation';
import classes from './EventTicketPDF.module.css';
import { EventTicketInfo } from './eventTicketsPdf.types';

interface EventTicketPDFProps extends EventTicketInfo {
  className?: string;
  eventTitle?: string;
}

const EventTicketPDF = ({
  eventTitle,
  eventStartDate,
  venueName,
  addressLineOne,
  addressLineTwo,
  city,
  state,
  zipCode,
  ticketName,
  ticketId,

  ticketQrCodeUrl,
  className,
}: EventTicketPDFProps) => {
  const isLocationEmpty = useMemo(
    () => !venueName && !addressLineOne && !city && !state && !zipCode,
    [venueName, addressLineOne, city, state, zipCode]
  );

  return (
    <Group className={cx(classes.EventTicketPDF, className)}>
      <Box p="md">
        <QRCode value={ticketQrCodeUrl} id="qr-gen" size={200} />
      </Box>
      <Box className={classes.EventTicketPDF__cutout}>
        <Box className={classes.EventTicketPDF__cutoutTop} />
        <Box className={classes.EventTicketPDF__cutoutBottom} />
      </Box>
      <Divider
        variant="dashed"
        orientation="vertical"
        size="sm"
        className={classes.EventTicketPDF__divider}
      />
      <Box flex={1}>
        <Text fz="lg" fw={600} pb={0}>
          {eventTitle || 'Your Event'}
        </Text>
        <EventDateTime startDate={eventStartDate} />
        <Divider />
        {!isLocationEmpty && (
          <>
            <EventLocation
              venueName={venueName}
              addressLineOne={addressLineOne}
              addressLineTwo={addressLineTwo}
              city={city}
              state={state}
              zipCode={zipCode}
            />
            <Divider />
          </>
        )}
        <Group p="sm">
          <Stack gap={4} p={4} flex={1}>
            <Text fz="xs" c="gray.6">
              Ticket Name
            </Text>
            <Text fz="sm" fw={600}>
              {ticketName}
            </Text>
          </Stack>

          <Divider orientation="vertical" />
          <Stack gap={4} p={4} flex={1}>
            <Text fz="xs" c="gray.6">
              Ticket ID
            </Text>
            <Text fz="sm" fw={600}>
              {ticketId}
            </Text>
          </Stack>
        </Group>
      </Box>
    </Group>
  );
};

export { EventTicketPDF };
